import { render, staticRenderFns } from "./orderpercentage.vue?vue&type=template&id=3e44ac52&scoped=true"
import script from "./orderpercentage.vue?vue&type=script&lang=js"
export * from "./orderpercentage.vue?vue&type=script&lang=js"
import style0 from "./orderpercentage.vue?vue&type=style&index=0&id=3e44ac52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e44ac52",
  null
  
)

export default component.exports